import React from "react";
import PropTypes from "prop-types";
import { FormField, SpaceBetween } from "@amzn/awsui-components-react";
import TextContent from "@amzn/awsui-components-react/polaris/text-content";
import Input from "@amzn/awsui-components-react/polaris/input";
import Textarea from "@amzn/awsui-components-react/polaris/textarea";
import { itemInputValidation, modalErrorMessage } from "../constant";
import { useParams } from "react-router-dom";
import { generateLengthConstraintText } from "../util";

const DeleteModalForm = ({ item, setItem, errors, updateErrors }) => {
  const { entity } = useParams();
  const validateDelete = (value) => {
    if (value.length > "delete".length) {
      updateErrors({
        ...errors,
        delete: modalErrorMessage.delete,
      });
    } else {
      updateErrors({ ...errors, delete: "" });
      setItem({ ...item, delete: value });
    }
  };

  const validateReason = (value) => {
    if (value.length > itemInputValidation.reason.limit) {
      updateErrors({
        ...errors,
        reason: itemInputValidation.reason.message,
      });
    } else {
      updateErrors({ ...errors, reason: "" });
      setItem({ ...item, reason: value });
    }
  };

  return (
    <SpaceBetween size="l">
      <TextContent>
        <p>
          Are you sure you want to delete the below item of Entity(
          {entity})?
        </p>
        <p>
          Item Name: {item.name}
          <br></br>Item Description: {item.value}
        </p>
      </TextContent>
      <FormField
        label="Please type 'delete' to confirm"
        errorText={errors.delete}
      >
        <Input
          id="Name"
          value={item.delete}
          onChange={({ detail }) => validateDelete(detail.value)}
        />
      </FormField>
      <FormField
        label={
          <span>
            Reason <i>- optional</i>
          </span>
        }
        constraintText={generateLengthConstraintText(
          item.reason,
          itemInputValidation.reason.limit
        )}
        errorText={errors.reason}
      >
        <Textarea
          id="reason"
          value={item.reason}
          onChange={({ detail }) => validateReason(detail.value)}
        />
      </FormField>
    </SpaceBetween>
  );
};

DeleteModalForm.propTypes = {
  item: PropTypes.object,
  setItem: PropTypes.func,
  errors: PropTypes.object,
  updateErrors: PropTypes.func,
};

export default DeleteModalForm;
